import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { AngularSvgIconModule } from 'angular-svg-icon';
import { DirectivesModule } from 'Core/directives/directives.module';
import { NgxPermissionsModule } from 'ngx-permissions';
import { NgZorroModule } from 'Shared/modules/ng-zorro/ng-zorro.module';
import { SessionDropdownComponent } from './components/session-dropdown/session-dropdown.component';
import { HeaderComponent } from './header/header.component';
import { ShellRoutingModule } from './shell-routing.module';
import { ShellComponent } from './shell/shell.component';
import { SidenavComponent } from './sidenav/sidenav.component';

const COMPONENTS = [HeaderComponent, ShellComponent, SidenavComponent, SessionDropdownComponent];

@NgModule({
  declarations: COMPONENTS,
  imports: [
    RouterModule,
    ShellRoutingModule,
    NgxPermissionsModule.forChild(),
    NgZorroModule,
    CommonModule,
    AngularSvgIconModule,
    DirectivesModule,
  ],
  exports: COMPONENTS,
})
export class ShellModule {}
